<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <table width="100%" class="mb-2">
        <thead>
          <th>No</th>
          <th>Kode Container</th>
          <th>No Container</th>
          <th>Tgl Stuffing</th>
          <th>Prioritas</th>
          <th>Cargo</th>
          <th style="text-align: right">Kubikasi (M3)</th>
          <th style="text-align: right">Tonase (Ton)</th>
        </thead>
        <tbody>
          <tr v-for="(container, i) in data" :key="container.id">
            <td>{{ i + 1 }}</td>
            <td>{{ container.kc }}</td>
            <td>{{ container.no_container }}</td>
            <td>{{ formatDate(container.tgl_stuffing) }}</td>
            <td>{{ container.prioritas_berangkat }}</td>
            <td>{{ container.cargo }}</td>
            <td style="text-align: right">
              {{ formatDecimal(container.total_m3) }}
            </td>
            <td style="text-align: right">
              {{ formatDecimal(container.total_ton) }}
            </td>
          </tr>
          <tr>
            <td colspan="6" style="text-align: right">
              <b>Total Keseluruhan:</b>
            </td>
            <td style="text-align: right">
              <b>{{ formatDecimal(sumField("total_m3")) }}</b>
            </td>
            <td style="text-align: right">
              <b>{{ formatDecimal(sumField("total_ton")) }}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- Print Button -->
    <!-- <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.kv"
      @click="printDocument"
    >
      Print
    </v-btn> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: {}
    };
  },
  methods: {
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`container-belum-berangkat`)
        .then(res => {
          this.data = res.data;

          if (res.data.length == 0) {
            this.state.noData = true;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    sumField(field) {
      return (Array.isArray(this.data) ? this.data : []).reduce(
        (sum, item) => sum + (Number(item[field]) || 0),
        0
      );
    },
    formatDecimal(value) {
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(value) || 0);
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 80%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}
</style>
